var React = require('react');

function IcCheckMark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.13211 15.4675L5.40057 11.736L4.12988 12.9977L9.13211 18L19.8703 7.26174L18.6086 6L9.13211 15.4675Z","fill":"currentColor"}));
}

IcCheckMark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcCheckMark;

IcCheckMark.default = IcCheckMark;
